import { useContext } from 'react';
import { AuthContext } from 'contexts/auth_context';

const useAuth = () => {
    return useContext(AuthContext);
};

export default useAuth;
